/**
 * Manages Excursions
 */
var ExcursionHandler = /** @class */ (function () {
    function ExcursionHandler(props) {
        this.clicked = false;
        this.buttonId = props.buttonId;
        this.excursionName = props.excursionName;
        this.init();
    }
    ExcursionHandler.prototype.init = function () {
        var _this = this;
        this.excursionField = document.getElementById("ExcursionsEnquiryForm_Enquiry");
        this.excursionText = "\n- ".concat(this.excursionName);
        this.button = document.querySelector("#".concat(this.buttonId));
        this.button.addEventListener("click", function () {
            _this.swapState();
        });
    };
    ExcursionHandler.prototype.swapState = function () {
        if (!this.clicked) {
            this.excursionField.value = "".concat(this.excursionField.value, " ").concat(this.excursionText);
            this.button.innerText = "REMOVE FROM ENQUIRY";
            this.button.style.borderColor = "#b22815";
            this.button.style.color = "#b22815";
        }
        else {
            this.excursionField.value = this.excursionField.value.replace(this.excursionText, "");
            this.button.innerText = "ADD TO ENQUIRY";
            this.button.style.borderColor = "#00437a";
            this.button.style.color = "#00437a";
        }
        this.clicked = !this.clicked;
    };
    return ExcursionHandler;
}());
export { ExcursionHandler };
export default ExcursionHandler;
